import { call, put } from 'redux-saga/effects';
import { userConstants } from '../actions/constants/userConstants';
import { userService } from '../services/userService';
import { commonActions } from '../actions/commonAction';
import { commonConstants } from '@/actions/constants/commonConstants';
import { localData, sessionData } from "@/services/helper";

function* listUsersSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.listUsers, action.payload);
    if (response.success) {
      yield put({
        type: userConstants.listUsersSuccess,
        payload: response.resultObject,
      });
    } else {
      yield put({
        type: userConstants.listUsersFailure,
        payload: response.message,
      });
      yield put(commonActions.errorResponse(response.message || 'Failed to fetch users'));
    }
  } catch (error: any) {
    yield put({
      type: userConstants.listUsersFailure,
      payload: error.message,
    });
    yield put(commonActions.errorResponse(error.message || 'An error occurred'));
  }
}

function* listMembersSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.listUsers, action.payload);

    if (response.success) {
      yield put({
        type: userConstants.listMembersSuccess,
        payload: response.resultObject,
      });
    } else {
      yield put({
        type: userConstants.listMembersFailure,
        payload: response.message,
      });
      yield put(commonActions.errorResponse(response.message || 'Failed to fetch members'));
    }
  } catch (error: any) {
    yield put({
      type: userConstants.listMembersFailure,
      payload: error.message,
    });
    yield put(commonActions.errorResponse(error.message || 'An error occurred'));
  }
}

function* listPhotographersSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.listUsers, action.payload);

    if (response.success) {
      yield put({
        type: userConstants.listPhotographersSuccess,
        payload: response.resultObject,
      });
    } else {
      yield put({
        type: userConstants.listPhotographersFailure,
        payload: response.message,
      });
      yield put(commonActions.errorResponse(response.message || 'Failed to fetch photographers'));
    }
  } catch (error: any) {
    yield put({
      type: userConstants.listPhotographersFailure,
      payload: error.message,
    });
    yield put(commonActions.errorResponse(error.message || 'An error occurred'));
  }
}

function* inviteUserSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.inviteUser, action.payload);

    if (response.success) {
      yield put({
        type: userConstants.inviteUserSuccess,
        payload: response.resultObject,
      });
      yield put({
        type: userConstants.listUsersSuccess, payload: response.resultObject,
      });
    } else {
      yield put({
        type: userConstants.inviteUserFailure,
        payload: response.message,
      });
      yield put(commonActions.errorResponse(response.message || 'Failed to invite user'));
    }
  } catch (error: any) {
    yield put({
      type: userConstants.inviteUserFailure,
      payload: error.message,
    });
    yield put(commonActions.errorResponse(error.message || 'An error occurred'));
  }
}

function* viewUser(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.viewUser, action.payload);
    if (response.success) {
      const localUser: any = localData.get("AUTHDATA");
      const sessionUser: any = sessionData.get("AUTHDATA");
      if (localUser?.id === response.resultObject?.userDetails?.userId || sessionUser?.id === response.resultObject?.userDetails?.userId) {
        const updatedUser = {
          ...localUser,
          kycVerification: response.resultObject?.userDetails?.kycVerification,
          subscriptionStatus: response.resultObject?.subscriptionStatus,
        }
        localData.set("AUTHDATA", updatedUser);
        sessionData.set("AUTHDATA", updatedUser);
      }
      yield put({ type: userConstants.viewUserSuccess, payload: response.resultObject });

    } else {
      yield put({
        type: userConstants.viewUserFailure,
        payload: response.message,
      });
      yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({
      type: userConstants.viewUserFailure,
      payload: error.message,
    });
    yield put(commonActions.errorResponse(error.message || 'An error occurred'));
  }
}
function* editUser(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.editUser, action.payload);
    if (response.success) {
      yield put({ type: userConstants.editUserSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
    } else {
      yield put({ type: userConstants.editUserFailure, payload: response.message });
      yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({
      type: userConstants.editUserFailure,
      payload: error.message,
    });
    yield put({ type: commonConstants.showErrorMessage, payload: error });
  }
}
function* deleteUserSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.deleteUserRequest, action.payload);

    if (response.success) {
      yield put({ type: userConstants.deleteUserSuccess, payload: response.resultObject });
      yield put(commonActions.successResponse(response.message));
    } else {
      yield put({ type: userConstants.deleteUserFailure, payload: response.message });
      yield put(commonActions.errorResponse((response.message || response.errorMessage || 'Failed to process delete request')));
    }
  } catch (error: any) {
    yield put({ type: userConstants.deleteUserFailure, payload: error.message });
    const errorMessage = error.response?.data?.message || error.response?.data?.errorMessage || error.message || 'An error occurred while processing the delete request';
    yield put(commonActions.errorResponse(errorMessage));
  }
}

function* processDeleteRequestSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.processDeleteRequest, action.payload);

    if (response.success) {
      yield put({ type: userConstants.processDeleteSuccess, payload: response.resultObject, });
      yield put(commonActions.successResponse(response.message || 'Delete request processed successfully'));
    } else {
      yield put({ type: userConstants.processDeleteFailure, payload: response.message });
      const errorMessage = response.message || response.errorMessage || 'Failed to process delete request';
      yield put(commonActions.errorResponse(errorMessage));
    }
  } catch (error: any) {
    yield put({ type: userConstants.processDeleteFailure, payload: error.message });
    const errorMessage = error.response?.data?.message || error.response?.data?.errorMessage || error.message || 'An error occurred while processing the delete request';
    yield put(commonActions.errorResponse(errorMessage));
  }
}

function* listDeleteRequestsSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.listDeleteRequests, action.payload);

    if (response.success) {
      yield put({ type: userConstants.listDeleteRequestsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: userConstants.listDeleteRequestsFailure, payload: response.message });
      yield put(commonActions.errorResponse(response.message || 'Failed to fetch delete requests'));
    }
  } catch (error: any) {
    yield put({
      type: userConstants.listDeleteRequestsFailure,
      payload: error.message,
    });
    yield put(commonActions.errorResponse(error.message || 'An error occurred'));
  }
}

function* revokeUserSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.revokeUser, action.payload);

    if (response.success) {
      yield put({ type: userConstants.revokeUserSuccess, payload: response.resultObject });
      yield put(commonActions.successResponse(response.message || 'User reactivated successfully'));
    } else {
      yield put({ type: userConstants.revokeUserFailure, payload: response.message });
      yield put(commonActions.errorResponse(response.message || response.errorMessage || 'Failed to reactivate user'));
    }
  } catch (error: any) {
    yield put({ type: userConstants.revokeUserFailure, payload: error.message });
    const errorMessage = error.response?.data?.message || error.response?.data?.errorMessage || error.message || 'An error occurred while reactivating the user';
    yield put(commonActions.errorResponse(errorMessage));
  }
}

function* submitUpdateRequestSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.submitUpdateRequest, action.payload);

    if (response.success) {
      yield put({ type: userConstants.submitUpdateRequestSuccess, payload: response.resultObject });
      yield put(commonActions.successResponse(response.message || 'Update request submitted successfully'));
    } else {
      yield put({ type: userConstants.submitUpdateRequestFailure, payload: response.message });
      yield put(commonActions.errorResponse(response.message || response.errorMessage || 'Failed to submit update request'));
    }
  } catch (error: any) {
    yield put({ type: userConstants.submitUpdateRequestFailure, payload: error.message });
    const errorMessage = error.response?.data?.message || error.response?.data?.errorMessage || error.message || 'An error occurred while submitting the update request';
    yield put(commonActions.errorResponse(errorMessage));
  }
}

function* processUpdateRequestSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.processUpdateRequest, action.payload);
    if (response.success) {
      yield put({ type: userConstants.processUpdateRequestSuccess, payload: response.resultObject });
      yield put(commonActions.successResponse(response.message || 'Update request processed successfully'));
    } else {
      yield put({ type: userConstants.processUpdateRequestFailure, payload: response.message || response.errorMessage });
      yield put(commonActions.errorResponse(response.message || response.errorMessage || 'Failed to process update request'));
    }
  } catch (error: any) {
    yield put({ type: userConstants.processUpdateRequestFailure, payload: error.message });
    const errorMessage = error.response?.data?.message || error.response?.data?.errorMessage || error.message || 'An error occurred while processing the update request';
    yield put(commonActions.errorResponse(errorMessage));
  }
}

function* listUpdateRequestsSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(userService.listUpdateRequests, action.payload);
    if (response.success) {
      yield put({ type: userConstants.listUpdateRequestsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: userConstants.listUpdateRequestsFailure, payload: response.message });
      yield put(commonActions.errorResponse(response.message || 'Failed to fetch update requests'));
    }
  } catch (error: any) {
    yield put({ type: userConstants.listUpdateRequestsFailure, payload: error.message });
    yield put(commonActions.errorResponse(error.message || 'An error occurred'));
  }
}

function* viewKycDocumentSaga(action: any): Generator<any, void, any> {
  try {
    const userId = action.payload;
    const response = yield call(userService.getKycEncryptedDocument, userId);
    if (response.success) {
      yield put({ type: userConstants.viewKycdocumentSuccess, payload: response.resultObject });
      yield put(commonActions.successResponse(response.message || 'KYC document fetched successfully'));
    } else {
      yield put({ type: userConstants.viewKycdocumentFailure, payload: response.message });
      yield put(commonActions.errorResponse(response.message || 'Failed to fetch KYC document'));
    }
  } catch (error: any) {
    yield put({ type: userConstants.viewKycdocumentFailure, payload: error.message });
    yield put(commonActions.errorResponse(error.message || 'An error occurred'));
  }
}

export const userSagaFunctions = {
  listUsers: listUsersSaga,
  listMembers: listMembersSaga,
  listPhotographers: listPhotographersSaga,
  inviteUser: inviteUserSaga,
  viewUser,
  editUser,
  deleteUser: deleteUserSaga,
  processDeleteRequest: processDeleteRequestSaga,
  listDeleteRequests: listDeleteRequestsSaga,
  revokeUser: revokeUserSaga,
  submitUpdateRequest: submitUpdateRequestSaga,
  processUpdateRequest: processUpdateRequestSaga,
  listUpdateRequests: listUpdateRequestsSaga,
  viewKycdocument: viewKycDocumentSaga,
};

